module.exports = __webpack_public_path__ + "static/ebis-88082095c83ba1d45263c8da9a50618f.png";